<template>
  <div class="container">
    <div
      id="page1-div"
      class="container interline border page-container"
    >
      <div class="col-12 p-4">
        <div class="col-12 text-center pt-5 pb-4">
          <u class="ft12Black">
            CARTA CONTRATACIÓN DE SERVICIOS DE LOCALIZACIÓN VÍA SATÉLITE
          </u>
        </div>
        <div class="col-12 text-right">
          <span class="ft11">
            CD, <span v-bind:class="{ marca: data.showMarca }">
              {{ data.municipio_cliente }},</span> <span v-bind:class="{ marca: data.showMarca }">
              {{ data.estado_cliente }},</span> <span v-bind:class="{ marca: data.showMarca }">
              {{ data.fecha_contrato}}.</span>
          </span>
        </div>
        <div class="col-12 text-justify pt-4">
          <span class="ft10">
            Apoderado o Representante Legal de GPI AUTO COMERCIAL SAPI DE
            C.V.<br />
            <br />
            Hacemos referencia al contrato de apertura de crédito simple con
            garantía prendaria sin transmisión de la posesión que el día de hoy
            celebré con ustedes (en adelante el" Contrato"). Por medio de la
            presente solicito que la sociedad GPI AUTO COMERCIAL SAPI DE C.V.
            (en adelante <u class="ft10">CREDIMOVIL,</u>), me brinde el servicio
            de localización vía Satélite, y lleve a cabo la instalación del
            dispositivo de localización correspondiente, el cual será otorgado
            en comodato, con respecto al siguiente Bien:
            <br />
            <br />
            Descripción de Vehículo:<br />
            Marca: <span v-bind:class="{ marca: data.showMarca }">
              {{ data.marca_vehiculo}}</span><br />
            Año: <span v-bind:class="{ marca: data.showMarca }">
              {{ data.año_vehiculo}}</span><br />
            Modelo: <span v-bind:class="{ marca: data.showMarca }">
              {{ data.modelo_vehiculo}}</span><br />
            Número de Motor: <span v-bind:class="{ marca: data.showMarca }">
              {{ data.numero_motor_vehiculo}}</span><br />
            Número de Serie: <span v-bind:class="{ marca: data.showMarca }">
              {{ data.numero_serie_vehiculo}}</span><br />
            <br />
            Por medio de la presente me obligo a pagar la comisión establecida
            en la Carátula del Contrato, la cual será pagadera el Día Hábil en
            que deba pagarse cada Parcialidad, según dichos términos se
            encuentran establecidos en el presente Contrato.
            <br />
            Adicionalmente por medio de la presente me obligo a permitir el
            libre acceso al Bien en donde se encuentre instalado el dispositivo,
            al personal autorizado por <u class="ft10">CREDIMOVIL,</u> o de
            cualquier tercero autorizado por <u class="ft10">CREDIMOVIL,</u>,
            para realizar la verificación, inspección, mantenimiento, o en su
            caso recoger el dispositivo, o por cualquier otra causa, previa
            identificación y presentación de la orden de trabajo correspondiente
            del personal autorizado por <u class="ft10">CREDIMOVIL,</u> en la
            que se detalla el motivo de la visita, en el entendido de que dichos
            servicios de mantenimiento o sustitución del dispositivo, no tendrán
            costo adicional para el suscrito.
            <br />
            La vigencia del presente documento será forzosa durante la vigencia
            del Contrato y/o una vez liquidado el Crédito, y por medio de la
            presente me obligo a devolver el dispositivo de localización vía
            satélite instalado en el Bien a <u class="ft10">CREDIMOVIL,</u>, al
            término de dicha vigencia; por lo que en caso de no devolver el
            dispositivo, me obligo a pagar a la sociedad
            <u class="ft10">CREDIMOVIL,</u>, la cantidad de $3,500.00 Pesos
            (Tres mil Quinientos Pesos 00/100 M.N.), por concepto de pago total
            de dicho dispositivo, de forma inmediata.
            <br />
            El Acreditado tendrá cinco dias naturales para reportar algún
            defecto o anomalía en el Vehículo después de haber sido instalado el
            dispositivo localizador.
            <br />
            Adicionalmente, el suscrito se obliga a no remover, extraer,
            cambiar, añadir, alterar, rallar, dañar, marcar o de cualquier otra
            forma modificar el dispositivo de localización vía satélite ni a
            utilizarlo para cualquier otro fin distinto al pactado en el
            presente documento.
          </span>
        </div>
        <div class="col-12 row p-5">
          <div class="col-4 text-center"></div>
          <div class="col-4 border-dark text-center">
            <span class="ft11">
              ATENTAMENTE
            </span>
          </div>
          <div class="col-4 text-center"></div>
        </div>
        <div v-if="data.tipoClasico" class="col-12 row">
          <div class="col-3 text-center"></div>
          <div class="col-6 border-bottom border-dark text-center">
            <span v-bind:class="{ marca: data.showMarca }" class="ft11 ">
              {{ data.nombre_cliente }}
            </span>
          </div>
          <div class="col-3 text-center"></div>
        </div>
        <div v-if="data.tipoClasico" class="col-12 row ">
          <div class="col-3 text-center"></div>
          <div class="col-6 text-center pb-5">
            <span class="ft11">
              NOMBRE Y FIRMA DEL ACREDITADO
            </span>
          </div>
          <div class="col-3 text-center"></div>
        </div>
        <div v-if="data.tipoAval" class="col-12 row pt-4">
          <div class="col-4 offset-1 border-top border-dark text-center">
            <span class="ft11">
              <span v-bind:class="{ marca: data.showMarca }" class="ft10Black">
                {{ data.nombre_cliente }}</span
              ><br />
              NOMBRE Y FIRMA DEL ACREDITADO
            </span>
          </div>
          <div class="col-3 text-center">
            <span class="ft11">

            </span>
          </div>
          <div class="col-4 border-top border-dark text-center">
            <span class="ft11">
              <span v-bind:class="{ 'marca-aval': data.showMarca }" class="ft10Black">
                {{ data.nombre_aval }}</span
              ><br />
              NOMBRE Y FIRMA DEL AVAL Y OBLIGADO SOLIDARIO

            </span>
          </div>
        </div>
        <div v-if="data.tipoObligado" class="col-12 row pt-4">
          <div class="col-4 offset-1 border-top border-dark text-center">
            <span class="ft11">
              <span v-bind:class="{ marca: data.showMarca }" class="ft10Black">
                {{ data.nombre_cliente }}</span
              ><br />
              NOMBRE Y FIRMA DEL ACREDITADO
            </span>
          </div>
          <div class="col-3 text-center">
            <span class="ft11">

            </span>
          </div>
          <div class="col-4 border-top border-dark text-center">
            <span class="ft11">
              <span v-bind:class="{ 'marca-obligado': data.showMarca }" class="ft10Black">
                {{ data.nombre_obligado }}</span
              ><br />
              NOMBRE Y FIRMA DEL AVAL Y OBLIGADO SOLIDARIO

            </span>
          </div>
        </div>
        <div v-if="data.tipoObligadoAval" class="col-12 row pt-4">
          <div class="col-3 offset-1 border-top border-dark text-center">
            <span class="ft9">
              <span v-bind:class="{ marca: data.showMarca }" class="ft9Black">
                {{ data.nombre_cliente }}</span
              ><br />
              NOMBRE Y FIRMA DEL ACREDITADO
            </span>
          </div>
          <div class="col-3 offset-1 border-top border-dark text-center">
            <span class="ft9">
              <span v-bind:class="{ 'marca-aval': data.showMarca }" class="ft9Black">
                {{ data.nombre_aval }}</span
              ><br />
              NOMBRE Y FIRMA DEL AVAL Y OBLIGADO SOLIDARIO

            </span>
          </div>
          <div class="col-3 offset-1 border-top border-dark text-center">
            <span class="ft9">
              <span v-bind:class="{ 'marca-obligado': data.showMarca }" class="ft9Black">
                {{ data.nombre_obligado }}</span
              ><br />
              NOMBRE Y FIRMA DEL“AVAL Y OBLIGADO SOLIDARIO"

            </span>
          </div>
        </div>
        <div class="col-12 row pt-5">
          <div class="col-3 text-center"></div>
          <div class="col-6 border-bottom border-dark text-center"></div>
          <div class="col-3 text-center"></div>
        </div>
        <div class="col-12 row ">
          <div class="col-3 text-center"></div>
          <div class="col-6 text-center">
            <span class="ft11">
              Aceptación y conformidad<br />
              GPI AUTO COMERCIAL SAPI DE C.V.<br />
              Representante Legal
            </span>
          </div>
          <div class="col-3 text-center"></div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: "IntruccionPAgoTErceros",
  data() {
    return {};
  },
  validations() {
    return {};
  },
  props: {
    data: {
      type: Object
    }
  },
  methods: {},
  created() {
    window.scrollTo(0, 0);
  }
};
</script>
<style type="text/scss">
@import "../style.scss";
</style>



// WEBPACK FOOTER //
// src/views/Contratos/cartas/LocalizacionSatelite.vue